/**
 * ВЫКЛАДКА УНОСИТ КУСКИ СБОРКИ, КОТОРЫЕ ДЕРЖИТ ОТКРЫТАЯ ВКЛАДКА.
 *
 * ПОВОД, 31.10.2026. Владелец на деве получил экран «SoundCheckBox failed to start» с текстом
 * `Failed to fetch dynamically imported module: …/assets/crew-person-page-BuGS6IZj.js`. Измерено по
 * самому деву: этот файл отдаёт 404, а в нынешней сборке тот же кусок называется
 * `crew-person-page-BRvPAA1w.js`. То есть страница была открыта ДО выкладки, держала старый список
 * файлов с хэшами в именах, и первый ленивый переход полез за куском, которого уже нет.
 *
 * Почему это нельзя оставлять: куски грузятся по переходу (двадцать мест в клиенте), а выкладка на
 * прод идёт при живых людях. Для человека это выглядит как «продукт сломался», хотя сломалась только
 * его вкладка, и лечится одним обновлением страницы.
 *
 * РЕШЕНИЕ — ПЕРЕЗАГРУЗИТЬ, НО РОВНО ОДИН РАЗ. Защёлка в `sessionStorage`: если мы уже
 * перезагружались в этой вкладке и ошибка повторилась, значит дело НЕ в устаревшей сборке (сеть,
 * прокси, вырезанный файл), и тогда человек должен увидеть настоящий экран с текстом, а не попасть
 * в кольцо перезагрузок. Хранилище может быть недоступно (приватное окно, запрет на данные сайта) —
 * тогда не перезагружаем вовсе: кольцо хуже одного честного экрана.
 */

/** Ключ защёлки. Живёт в сессии вкладки: новая вкладка пробует перезагрузку снова, и правильно. */
export const STALE_RELOAD_KEY = "scb-stale-build-reloaded";

/**
 * Это ошибка «кусок сборки не загрузился»? Текст берём из трёх браузеров:
 * Chrome — «Failed to fetch dynamically imported module», Firefox — «error loading dynamically
 * imported module», Safari — «Importing a module script failed».
 */
export function isStaleBuildError(err: unknown): boolean {
  const text = err instanceof Error ? `${err.message} ${err.stack ?? ""}` : String(err);
  return /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed/i.test(
    text
  );
}

export type StaleBuildAction = "reload" | "fatal";

/**
 * Что делать с такой ошибкой. Чистая функция: решение проверяется напрямую, без браузера.
 *
 * `alreadyReloaded` — защёлка уже стоит (мы перезагружались в этой вкладке).
 * `storageWorks` — `sessionStorage` доступен; без него защёлку поставить некуда.
 */
export function decideStaleBuildAction(ctx: { alreadyReloaded: boolean; storageWorks: boolean }): StaleBuildAction {
  if (!ctx.storageWorks) return "fatal";
  return ctx.alreadyReloaded ? "fatal" : "reload";
}
